import { Search as BaseSearch } from '@linearb/linui-common';
import React from 'react';
import { useFilters } from '../../../../hooks/useFilters';

const Search = props => {
  const { filters, deleteFilter, setFilter } = useFilters();

  function onSearchChange(newSearch) {
    if (newSearch) {
      setFilter('search', newSearch);
    } else {
      deleteFilter('search');
    }
  }

  return (
    <BaseSearch value={filters.search} onChange={onSearchChange} {...props} />
  );
};

export default Search;
